module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "passSet"
  }, [_c('div', {
    staticClass: "banner_wrapper"
  }, [_c('el-breadcrumb', {
    attrs: {
      "separator": ">"
    }
  }, [_c('el-breadcrumb-item', [_vm._v(_vm._s(_vm.$t('passSet.crumbs.L1')))]), _vm._v(" "), _c('el-breadcrumb-item', [_vm._v(_vm._s(_vm.$t('passSet.crumbs.L2')))])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "panel"
  }, [_c('div', {
    staticClass: "panel-header panel-header__fix"
  }, [_c('div', {
    staticClass: "panel-select-group"
  }, [_c('span', {
    staticClass: "panel-header__desc"
  }, [_vm._v(_vm._s(_vm.$t('passSet.crumbs.L2')))])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "myform_wrapper"
  }, [_c('div', {
    staticClass: "gray-explain"
  }, [_vm._v(_vm._s(_vm.$t('passSet.panel.explain')))]), _vm._v(" "), _c('div', {
    staticClass: "passState"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.$t('passSet.panel.passMsg')))]), _vm._v(" "), _c('div', {
    class: _vm.role.passState ? 'reset' : 'no-set'
  }, [_vm._v(_vm._s(_vm.role.passState ? _vm.$t('passSet.panel.states2') : _vm.$t('passSet.panel.states1')))]), _vm._v(" "), _c('div', {
    staticClass: "panel-header-btn panel-header-btn__fill",
    on: {
      "click": _vm.changePass
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.role.passState ? _vm.$t('passSet.panel.bt2') : _vm.$t('passSet.panel.bt1')))])])])])])]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.$t('passSet.panel.title1'),
      "visible": _vm.setPass,
      "custom-class": (_vm.lang === 'ja' || _vm.lang === 'en') ? 'mydialog haiwiadialog' : 'mydialog',
      "top": "20%",
      "show-close": false
    },
    on: {
      "update:visible": function($event) {
        _vm.setPass = $event
      },
      "close": function($event) {
        return _vm.handleClose('form1')
      }
    }
  }, [_c('el-form', {
    ref: "form1",
    attrs: {
      "model": _vm.form1,
      "rules": _vm.form1rules,
      "label-width": _vm.lang === 'en' ? '120px' : '90px'
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('passSet.panel.safe'),
      "prop": "pass"
    }
  }, [_c('el-input', {
    attrs: {
      "size": "small",
      "auto-complete": "new-password",
      "type": "password",
      "placeholder": _vm.$t('passSet.msg.m1')
    },
    model: {
      value: (_vm.form1.pass),
      callback: function($$v) {
        _vm.$set(_vm.form1, "pass", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "form1.pass"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('passSet.panel.pass'),
      "prop": "msgPass"
    }
  }, [_c('el-input', {
    attrs: {
      "size": "small",
      "auto-complete": "new-password",
      "type": "password",
      "placeholder": _vm.$t('passSet.msg.m2')
    },
    model: {
      value: (_vm.form1.msgPass),
      callback: function($$v) {
        _vm.$set(_vm.form1, "msgPass", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "form1.msgPass"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('passSet.panel.reEnter'),
      "prop": "rePass"
    }
  }, [_c('el-input', {
    attrs: {
      "size": "small",
      "auto-complete": "new-password",
      "type": "password",
      "placeholder": _vm.$t('passSet.msg.m3')
    },
    model: {
      value: (_vm.form1.rePass),
      callback: function($$v) {
        _vm.$set(_vm.form1, "rePass", $$v)
      },
      expression: "form1.rePass"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "divider"
  }), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('div', {
    staticClass: "cancel",
    on: {
      "click": function($event) {
        _vm.setPass = false
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('common.cancel')))]), _vm._v(" "), _c('div', {
    staticClass: "submit",
    on: {
      "click": function($event) {
        return _vm.submit(1)
      }
    }
  }, [(_vm.iconShow) ? _c('span', {
    staticClass: "el-icon-loading"
  }) : _c('span', [_vm._v(_vm._s(_vm.$t('common.confirm')))])])])], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.$t('passSet.panel.title2'),
      "visible": _vm.resetPass,
      "custom-class": (_vm.lang === 'ja' || _vm.lang === 'en') ? 'mydialog haiwiadialog' : 'mydialog',
      "top": "20%",
      "show-close": false
    },
    on: {
      "update:visible": function($event) {
        _vm.resetPass = $event
      },
      "close": function($event) {
        return _vm.handleClose('form2')
      }
    }
  }, [_c('el-form', {
    ref: "form2",
    attrs: {
      "model": _vm.form2,
      "rules": _vm.form2rules,
      "label-width": (_vm.lang === 'ja' || _vm.lang === 'en') ? '140px' : '90px'
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('passSet.panel.originPass'),
      "prop": "oldPass"
    }
  }, [_c('el-input', {
    attrs: {
      "size": "small",
      "auto-complete": "new-password",
      "type": "password",
      "placeholder": _vm.$t('passSet.msg.m6')
    },
    model: {
      value: (_vm.form2.oldPass),
      callback: function($$v) {
        _vm.$set(_vm.form2, "oldPass", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "form2.oldPass"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('passSet.panel.newPass'),
      "prop": "msgPass"
    }
  }, [_c('el-input', {
    attrs: {
      "size": "small",
      "auto-complete": "new-password",
      "type": "password",
      "placeholder": _vm.$t('passSet.msg.m7')
    },
    model: {
      value: (_vm.form2.msgPass),
      callback: function($$v) {
        _vm.$set(_vm.form2, "msgPass", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "form2.msgPass"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('passSet.panel.reEnter'),
      "prop": "rePass"
    }
  }, [_c('el-input', {
    attrs: {
      "size": "small",
      "auto-complete": "new-password",
      "type": "password",
      "placeholder": _vm.$t('passSet.msg.m8')
    },
    model: {
      value: (_vm.form2.rePass),
      callback: function($$v) {
        _vm.$set(_vm.form2, "rePass", $$v)
      },
      expression: "form2.rePass"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "gray-explain",
    staticStyle: {
      "margin-left": "0",
      "padding-top": "10px",
      "cursor": "pointer",
      "display": "inline-block"
    },
    on: {
      "click": _vm.forgetPassword
    }
  }, [_vm._v(_vm._s(_vm.$t('passSet.tip.m1')))])], 1), _vm._v(" "), _c('div', {
    staticClass: "divider"
  }), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('div', {
    staticClass: "cancel",
    on: {
      "click": function($event) {
        _vm.resetPass = false
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('common.cancel')))]), _vm._v(" "), _c('div', {
    staticClass: "submit",
    on: {
      "click": function($event) {
        return _vm.submit(2)
      }
    }
  }, [(_vm.iconShow) ? _c('span', {
    staticClass: "el-icon-loading"
  }) : _c('span', [_vm._v(_vm._s(_vm.$t('common.confirm')))])])])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// /home/qfpay/fe_node_modules/v7.10.1/fe_chain_store_admin_hk/~/_vue-loader@11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-66ffbc28"}!/home/qfpay/fe_node_modules/v7.10.1/fe_chain_store_admin_hk/~/_vue-loader@11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/components/passSetting/passSetting.vue
// module id = 921
// module chunks = 0